import { Component, OnInit } from '@angular/core';
import { LoginService } from 'src/app/authuntication/auth-service/login.service';

@Component({
  selector: 'app-second-header',
  templateUrl: './second-header.component.html',
  styleUrls: ['./second-header.component.scss']
})
export class SecondHeaderComponent implements OnInit {
  role: any;
  admin: any;
  admin_content: any;

  constructor(private _AuthService: LoginService) {
    this.userData();
  }

  userData() {
    if (this._AuthService.userData.sub.role === "super_admin") {
      this.role = true;
      this.admin_content = true;
      this.admin = true;
    }
    else if (this._AuthService.userData.sub.role === "admin_content") {
      this.admin_content = true;
      this.role = true;
      this.admin = false;
    } else if (this._AuthService.userData.sub.role === "admin") {
      this.admin_content = false;
      this.role = false;
      this.admin = true;
    } else {
      this.role = false;
    }
  }

  ngOnInit(): void {
  }

}